
import * as React from "react";
import { ColumnLayout, Icon } from '@amzn/awsui-components-react-v3';

export default class NotFound extends React.Component {
  constructor() {
      super(null)
  }

  render() {
    const randomNumber = (Math.floor(Math.random() * 43) + 1);

    return (
      <div style={{
          textAlign: 'center',
          backgroundColor: 'white'
      }}>
        <div className="awsui-util-container">
          <ColumnLayout>
            <h1><Icon size="large" name="status-stopped"></Icon> OOPS! PAGE NOT FOUND</h1><p>Sorry, we can't find that page!. It might be an old link or maybe it moved. Go to <a href='#/'>Homepage.</a>, or <a href="https://sim.amazon.com" target="_blank">let us know</a> if you need a hand.</p>
          </ColumnLayout>
        </div>

        <a href="https://www.amazon.com/dogsofamazon" target="_blank">
          <img id="not-found-dog" alt="Not Found" src={`https://images-na.ssl-images-amazon.com/images/G/01/error/${randomNumber}._TTD_.jpg"`} />
        </a>
      </div>
    );
  };
}